export default __webpack_public_path__ + "static/media/fo.57cc563e.svg";